module.exports = __webpack_public_path__ + "img/booking-date-active.4a88e561.svg";